var oldStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = function() {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.5b95691a40be4488a316da50e1a45098.js */ "./node_modules/.federation/entry.5b95691a40be4488a316da50e1a45098.js");
	}
	return oldStartup();
};